(function () {
  function clearBodyLockClasses() {
    var body = document.body;
    body.classList.remove('unloading', 'overflow-hidden', 'overflow-hidden-mobile', 'modal-open');

    body.classList.forEach(function (cls) {
      if (cls.indexOf('overflow-hidden-') === 0) {
        body.classList.remove(cls);
      }
    });
  }

  function closeOverlays() {
    document.querySelectorAll('cart-drawer.active').forEach(function (drawer) {
      if (typeof drawer.close === 'function') {
        drawer.close();
      } else {
        drawer.classList.remove('active', 'animate');
      }
    });

    document.querySelectorAll('details-modal[open], menu-drawer details[open]').forEach(function (node) {
      if (typeof node.close === 'function') {
        node.close();
      } else if (node.tagName === 'DETAILS') {
        node.removeAttribute('open');
      } else {
        node.classList.remove('active', 'menu-opening');
      }
    });

    document.querySelectorAll('.quick-add-modal[open], modal-dialog[open]').forEach(function (node) {
      if (typeof node.hide === 'function') {
        node.hide();
      } else if (typeof node.close === 'function') {
        node.close();
      } else {
        node.removeAttribute('open');
      }
    });
  }

  function resetUiLocks() {
    clearBodyLockClasses();
    closeOverlays();

    var preloader = document.getElementById('preloader');
    if (preloader) {
      preloader.style.display = 'none';
      preloader.style.animation = 'none';
    }

    document.querySelectorAll('[aria-disabled="true"]').forEach(function (el) {
      if (el.matches('button, [role="button"], .quick-add__submit, .product-form__submit')) {
        el.removeAttribute('aria-disabled');
      }
    });

    document.documentElement.classList.add('js');
    document.body.classList.add('loaded');
  }

  window.addEventListener('pageshow', function (event) {
    resetUiLocks();
    if (event.persisted) {
      requestAnimationFrame(resetUiLocks);
    }
  });

  window.addEventListener('popstate', function () {
    resetUiLocks();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      resetUiLocks();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resetUiLocks, { once: true });
  } else {
    resetUiLocks();
  }
})();
